import mapCurrencyToColor from "@/utils/currencyColorMapper";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class CurrencyColorMixin extends Vue {
  public mapCurrencyToColor(currency: string) {
    return mapCurrencyToColor(currency);
  }
}